import styled from 'styled-components';
import SideNav from 'components/SideNav';
import { Button } from '@mantine/core';
import { useAuth } from 'contexts/auth';
import { Outlet } from 'react-router-dom';

const StyledDashboards = styled.div`
  width: 100vw;
  background-color: rgb(241, 242, 244);
  min-height: 100vh;
  display: flex;
`;

const DashboardsLayout = () => {
  const { logout } = useAuth();

  return (
    <StyledDashboards>
      <SideNav />
      <Outlet />
      <Button
        color="red"
        variant="outline"
        onClick={logout}
        style={{ position: 'absolute', top: '20px', right: '30px' }}
      >
        Logout
      </Button>
    </StyledDashboards>
  );
};

export default DashboardsLayout;
